// extracted by mini-css-extract-plugin
export default {"content":"Insurance_content__OnUPn","card":"Insurance_card__EgiCR","heading":"Insurance_heading__4pDL8","img":"Insurance_img__wYGPp","callback":"Insurance_callback__1xNC7"};